// Mock data for Igor Campos Advocacia Landing Page

export const siteConfig = {
  name: "Igor Campos Advocacia",
  tagline: "Advocacia",
  whatsappNumber: "5531998538046",
  whatsappMessage: "Quero fazer uma análise da dívida da minha empresa",
  ctaText: "Analisar minha dívida agora",
  address: "Avenida Barao Homem de Melo, nº4494, Sala 1203, Estoril - Belo Horizonte - MG",
  phones: [
    { name: "Atendimento", number: "+55 (31) 99853-8046" }
  ]
};

export const heroData = {
  badge: "Renegociação de Dívidas Bancárias",
  headline: "Sua empresa está pagando caro demais pelo empréstimo?",
  subheadline: "As parcelas estão estrangulando o seu caixa, resolvemos para você, antes que vire uma bola de neve."
};

export const situacoesProblemas = [
  "Você fatura, mas a parcela come quase tudo",
  "O banco oferece “renegociação”, mas a dívida parece só aumentar",
  "Você paga juros que não fazem sentido",
  "A pressão do banco virou rotina",
  "Falta previsibilidade no caixa",
  "A empresa está rodando no limite"
];

export const situacoesSolucoes = [
  "Redução da pressão no caixa",
  "Estratégia clara",
  "Menos desgaste emocional",
  "Acompanhamento contínuo",
  "Condução completa da negociação",
  "Reorganização da dívida",
  "Planejamento financeiro realista"
];

export const conflitosText = {
  title: "Eu não sou o jurídico do não",
  paragraphs: [
    "Antes de ser advogado, eu fui empresário.",
    "Meu foco não é travar sua operação. É resolver o problema financeiro sem engessar o seu negócio.",
    "O objetivo aqui é simples: Colocar a dívida dentro da realidade do seu caixa, com estratégia, negociação e acompanhamento.",
    "Sem mágica. Sem discurso técnico. Com um plano para o negócio continuar rodando."
  ],
  cta: "Quero analisar meu caso agora"
};

export const cenarios = {
  title: "Dois cenários comuns",
  cenario1: {
    title: "Cenário 1 — Você continua tentando resolver sozinho",
    items: [
      "Você negocia com o banco, recebe propostas padrão e fica preso em condições que não aliviam o caixa.",
      "O risco cresce, o estresse aumenta e a empresa continua sangrando."
    ]
  },
  cenario2: {
    title: "Cenário 2 — Você entra com estratégia e tira o banco do seu dia a dia",
    items: [
      "Você entende o que está pagando, o que pode ser ajustado e entra com um plano realista para caber no caixa.",
      "O banco passa a falar com o escritório. Você volta a focar na operação."
    ]
  }
};

export const comoFunciona = {
  title: "Como funciona nosso trabalho",
  steps: [
    {
      number: "1",
      title: "Você explica sua situação",
      description: "Você conta rapidamente o que está acontecendo e responde algumas perguntas objetivas."
    },
    {
      number: "2",
      title: "Nós desenhamos a estratégia",
      description: "Analisamos seu negócio, sua realidade e a dívida para criar o melhor plano possível."
    },
    {
      number: "3",
      title: "Colocamos em prática",
      description: "Entramos na negociação e executamos tudo para o seu negócio voltar a respirar."
    },
    {
      number: "4",
      title: "Você sai da linha de frente",
      description: "A partir daqui, você não fala mais com o banco. Cuidamos de tudo, do começo ao fim."
    }
  ],
  cta: "Quero conversar no WhatsApp"
};

export const cenariosBridge = {
  text: "Agora você tem 2 possibilidades:"
};

export const paraQuem = {
  title: "Para quem é",
  subtitle: "Isso é para você se:",
  items: [
    "É empresário de pequena ou média empresa",
    "Tem parcelas bancárias recorrentes",
    "Quer reorganizar antes de entrar em crise",
    "Já está no limite e precisa reestruturar",
    "Quer alguém que assuma a negociação"
  ],
  cta: "Quero analisar meu caso agora"
};

export const ctaFinal = {
  title: "Quer entender se dá para melhorar sua situação com o banco?",
  subtitle: "Me chama no WhatsApp e eu te digo com clareza o que faz sentido no seu caso."
};

export const faqData = [
  {
    question: "Como sei se meu contrato tem juros abusivos?",
    answer: "Analisamos o contrato detalhadamente para identificar taxas acima da média de mercado e cláusulas ilegais."
  },
  {
    question: "O banco pode tomar meus bens?",
    answer: "Existem estratégias legais para proteger seu patrimônio enquanto negociamos a dívida."
  },
  {
    question: "Quanto tempo demora a renegociação?",
    answer: "Varia caso a caso, mas nosso objetivo é agir rápido para estancar o sangramento do caixa."
  }
];

export const objetivoText = {
  headline: "O objetivo aqui é simples",
  paragraphs: [
    "Colocar a dívida dentro da realidade do seu caixa, com estratégia, negociação e acompanhamento.",
    "Sem mágica. Sem discurso técnico. Com um plano para o negócio continuar rodando."
  ],
  cta: "FALAR COM ADVOGADO AGORA",
  cards: [
    {
      title: "Muita gente acha que “renegociar” é só aceitar o que o banco oferece.",
      subtitle: "Só que, em muitos casos, isso vira:",
      items: [
        "um novo contrato pior",
        "mais prazo + mais juros",
        "uma dívida que parece “controlada”, mas cresce silenciosamente"
      ],
      conclusion: "Aqui a ideia é renegociar com estratégia — para o pagamento fazer sentido e o caixa voltar a respirar."
    },
    {
      title: "Eu não sou o “jurídico do não”.",
      subtitle: "Antes de ser advogado, eu fui empresário.",
      description: "Isso muda tudo, porque meu foco não é travar sua operação. É resolver o problema sem engessar seu negócio. A minha função é te dar segurança e manter o negócio andando."
    }
  ]
};
